<template>
  <div>
    <div class="content-wrapper">
      <section class="content-header">
        <h1>
          Avertissements
          <small></small>
        </h1>
        <ol class="breadcrumb">
          <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
          <li><a href="#">Avertissements</a></li>
          <li class="active"><a href="#">Avertissements généraux</a></li>
        </ol>
      </section>

      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="nav-tabs-custom nav-tabs-custom-bottom">
              <ul class="nav nav-tabs" role="tablist">
                <li :class="active==1 ? 'active' : '' ">
                  <a href="#member_tab_1"
                     aria-controls="#member_tab_1"
                     data-toggle="tab"
                     @click="active=1"

                     aria-expanded="false">Membres</a>
                </li>
                <li :class="active==2 ? 'active' : '' ">
                  <a href="#member_tab_2"
                     aria-controls="#member_tab_2"
                     data-toggle="tab"
                     @click="active=2"
                     aria-expanded="false">Clubs</a>
                </li>

                <li :class="active==4 ? 'active' : '' ">
                  <a href="#member_tab_4"
                     aria-controls="#member_tab_4"
                     data-toggle="tab"
                     @click="active=4"
                     aria-expanded="false">Récapitulatifs</a>
                </li>

                <li :class="active==3 ? 'active' : '' ">
                  <a href="#member_tab_3"
                     aria-controls="#member_tab_3"
                     data-toggle="tab"
                     @click="active=3"
                     aria-expanded="false">Competitions & ranking</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row tab-content">
          <div role="tabpanel" :class="active==1 ? 'active' : '' " class="col-md-12 tab-pane " id="member_tab_1">
            <AvertissementMembre></AvertissementMembre>
          </div>

          <div role="tabpanel" :class="active==2 ? 'active' : '' " class="col-md-12 tab-pane" id="member_tab_2">
            <AvertissementClub></AvertissementClub>
            <!--<GeneralComites></GeneralComites>-->
          </div>
          <div role="tabpanel" :class="active==4 ? 'active' : '' " class="col-md-12 tab-pane" id="member_tab_4">
            <AvertissementRecapitulatif></AvertissementRecapitulatif>
          </div>
          <div role="tabpanel" :class="active==3 ? 'active' : '' " class="col-md-12 tab-pane" id="member_tab_3">
            <AvertissementRanking></AvertissementRanking>
          </div>


        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import AvertissementMembre from './Avertissement_membre'
import AvertissementClub from './Avertissement_club'
import AvertissementRanking from './Avertissement_ranking'
import AvertissementRecapitulatif from './Avertissement_recapitulatif'

export default {
  data() {
    return {
      loading: false,
      active: 1
    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    })
  },
  methods: {

  },

  watch: {},
  components: {
    AvertissementMembre: AvertissementMembre,
    AvertissementClub: AvertissementClub,
    AvertissementRanking: AvertissementRanking,
    AvertissementRecapitulatif: AvertissementRecapitulatif,
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Avertissement/AppAvertissement.vue